import React, { useState } from "react";
import { Form, Input, Button, message } from "antd";
import { useHistory } from "react-router-dom";
import { changePassword } from "../../../Services/UserService";

const ChangePasswordPage = ({ userData }) => {
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const onFinish = async (values) => {
    try {
      setLoading(true);
      if (!values) {
        throw new Error("Form values are undefined");
      }
      
      const { oldPassword, newPassword, confirmPassword } = values;
      if (newPassword !== confirmPassword) {
        return message.error("New passwords don't match!");
      }

      await changePassword(userData.userId, { oldPassword, newPassword });
      message.success("Password changed successfully!");
      history.push("/user/welcome");
    } catch (error) {
      console.error("Password change error:", error);
      message.error(error.response?.data?.message || error.message || "Failed to change password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ 
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "100vh",
      padding: "16px"
    }}>
      <div style={{
        width: "100%",
        maxWidth: "400px",
        padding: "24px",
        backgroundColor: "white",
        borderRadius: "8px",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)"
      }}>
        <h2 style={{ textAlign: "center", marginBottom: "24px" }}>Change Password</h2>
        <Form
          name="changePassword"
          onFinish={onFinish}
          layout="vertical"
        >
          <Form.Item
            label="Current Password"
            name="oldPassword"
            rules={[{ required: true, message: "Please input your current password!" }]}
          >
            <Input.Password />
          </Form.Item>

          <Form.Item
            label="New Password"
            name="newPassword"
            rules={[{ required: true, message: "Please input your new password!" }]}
          >
            <Input.Password />
          </Form.Item>

          <Form.Item
            label="Confirm New Password"
            name="confirmPassword"
            dependencies={['newPassword']}
            rules={[
              { required: true, message: "Please confirm your new password!" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('newPassword') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('The two passwords do not match!'));
                },
              }),
            ]}
          >
            <Input.Password />
          </Form.Item>

          <Form.Item>
            <Button 
              type="primary" 
              htmlType="submit" 
              loading={loading}
              style={{ width: "100%" }}
            >
              Change Password
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default ChangePasswordPage;